import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild,} from "@angular/core";
import {Subject} from "rxjs";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {EditorView, ViewUpdate} from "@codemirror/view";
import {CodemirrorService} from "../../services/codemirror-service";
import {
    DxButtonModule,
    DxColorBoxModule,
    DxFileUploaderModule,
    DxFormModule,
    DxLoadIndicatorModule, DxPopupModule, DxSelectBoxModule, DxTemplateModule, DxTextBoxModule, DxValidatorModule
} from "devextreme-angular";
import {DxiItemModule, DxiValidationRuleModule} from "devextreme-angular/ui/nested";

@Component({
    selector: "css-template-editor",
    templateUrl: "./css-template-editor.html",
    imports: [
        DxButtonModule,
        DxColorBoxModule,
        DxFileUploaderModule,
        DxFormModule,
        DxLoadIndicatorModule,
        DxPopupModule,
        DxSelectBoxModule,
        DxTemplateModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxiItemModule,
        DxiValidationRuleModule
    ],
    styleUrls: ["./css-template-editor.scss"]
})
export class CssTemplateEditor implements AfterViewInit {
    @Input() code: any;
    @Input() schema: any;
    @Input() mode!: string;
    @Output() isUpdated: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild("editorZone")
    codeEditor: Element | undefined;

    codeChanged: Subject<string> = new Subject<string>();
    codemirror!: EditorView;

    constructor(private codemirrorService: CodemirrorService) {
        this.codeChanged
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe(this.onCodeChanged.bind(this));
    }

    ngAfterViewInit(): void {
        if (this.mode !== "css") return;
        // @ts-ignore
        this.codemirror = this.codemirrorService.getCssCmEditor(this.codeEditor!.nativeElement, this.code, this.onCodeUpdate.bind(this));
    }

    updateCode(code: string) {
        this.codemirror.dispatch({
            changes: {
                from: 0,
                to: this.codemirror.state.doc.length,
                insert: code
            }
        })
    }

    onCodeUpdate(update: ViewUpdate) {
        if (update.docChanged)
            this.codeChanged.next(update.state.doc.toString());
    }

    onCodeChanged(codeValue: any) {
        this.isUpdated.emit(codeValue);
    }
}
